import { wrapper } from '@/Store/index'
import { END } from 'redux-saga'
import { loadSelf } from '@fdn/profile_store'
import { useSelector } from 'react-redux'
import dynamic from 'next/dynamic'
import Env from 'Consts/env'

const cookie = require('cookie')

import { fetchWithCache } from 'Helpers/fetch'
import { ads_detik } from 'Helpers/utils'
import { fetchAds } from 'Helpers/fetchAds'
import MetaHeader from 'Containers/meta_header'

const Banner = dynamic(() => import('Components/banner/banner_server'), {
  ssr: true,
})

const Layout = dynamic(() => import('Containers/layout'), {
  ssr: true,
})

const TabArticle = dynamic(() => import('Containers/tab_article'), {
  ssr: true,
})
const CampaignArticle = dynamic(() => import('Containers/campaign_article'), {
  ssr: true,
})
const LatestArticle = dynamic(
  () => import('Containers/latest_article/latest_article'),
  { ssr: true },
)

const BeautyFiles = dynamic(
  () => import('Containers/beauty_files/beauty_files'),
  { ssr: true },
)
const Video = dynamic(() => import('Containers/video/video'), { ssr: true })

const BannerHome = dynamic(() => import('Containers/banner_home/banner_home'), {
  ssr: true,
})

const PopularArticle = dynamic(
  () => import('Containers/popular_article/popular_article'),
  { ssr: true },
)

const PeopleLifestyleArticle = dynamic(
  () => import('Containers/people_lifestyle_article/people_lifestyle_article'),
  { ssr: true },
)

const Home = (props) => {
  const isMobile = props.is_mobile


  const storeData = useSelector((state) => state)

  return (
    <Layout
      home
      page_type="frontpage"
      title={'Info, Makeup, Skincare, Trend'}
      is_mobile={isMobile}
      self={storeData.storeSelf}
      ads_head={props.adsHead}
      ads_foot={props.adsFoot}
    >
      <MetaHeader />
      <main>
        <section>
          <div className="container fluid">
            <div className="row">
              <div className="col p-0">
                {(props.ads?.static1 || props.ads?.billboard) ?
                  <Banner
                      name={!!isMobile ? 'staticbanner1' : 'billboard'}
                      placeholder={!!isMobile ? 'staticbanner1' : 'billboard'}
                      is_mobile={isMobile}
                      class_name="ads-billboard"
                      dataAds={!!isMobile ? props.ads?.static1 : props.ads?.billboard}
                  />
                  : null
                }

                {props.dataArticleFeatured?.data && (
                  <BannerHome
                    is_mobile={isMobile}
                    dataAds={props.ads?.static2}
                    sponsoredPost={props.dataArticleFeatured?.data}
                  />
                )}
              </div>
            </div>
          </div>
        </section>

        <section>
          <div className="container">
            <div className="row">
              <div className="col-12">
                <PopularArticle
                  is_mobile={isMobile}
                  dataPopular={
                    props.dataPopularArticles && props.dataPopularArticles.data
                  }
                />
              </div>
            </div>
          </div>
        </section>

        <section>
          <div className="container">
            <div className="row">
              <div className="col-12">
                <LatestArticle
                  is_mobile={isMobile}
                  dataArticleLatest={
                    props.dataArticleLatest && props.dataArticleLatest.data
                  }
                />
              </div>
            </div>
          </div>
        </section>

        <section>
          <div className="container fluid">
            <div className="row">
              <BeautyFiles
                is_mobile={isMobile}
                beauty_files={
                  props.dataBeautyFiles && props.dataBeautyFiles.data
                }
              />
            </div>
          </div>
        </section>
        {!!isMobile && props.ads?.static2 ? (
          <section>
            <Banner
              name="staticbanner2"
              placeholder="staticbanner2"
              is_mobile={isMobile}
              class_name="ads-staticbanner2"
              dataAds={props.ads?.static2}
            />
            <style>
              {`
					.ads-staticbanner2{
						text-align: center;
					}
					`}
            </style>
          </section>
        ) : null}
        <section>
          <div className="container">
            <div className="row">
              <div className="col-12">
                <CampaignArticle
                  is_mobile={isMobile}
                  dataArticleCampaign={props.dataArticleCampaign?.data?.data}
                  borderImage={props.dataArticleCampaign?.data?.border_image}
                  articleTitle={props.dataArticleCampaign?.data?.title_image}
                />
              </div>
            </div>
          </div>
        </section>

        {props.dataTabArticle?.data?.length > 0 && (
          <section>
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <TabArticle
                    is_mobile={isMobile}
                    tabData={props.dataTabArticle && props.dataTabArticle.data}
                    link_cta={
                      process.env.NEXT_PUBLIC_ROOT_DOMAIN +
                      '/blog/category/beauty-school'
                    }
                  />
                </div>
              </div>
            </div>
          </section>
        )}

        {!!isMobile && props.ads?.static3 ? (
          <section>
            <Banner
              name="staticbanner3"
              placeholder="staticbanner3"
              is_mobile={isMobile}
              class_name="ads-staticbanner3"
              dataAds={props.ads?.static3}
            />
            <style>
              {`
					.ads-staticbanner3{
						text-align: center;
					}
					`}
            </style>
          </section>
        ) : null}

        {!!props.dataArticleCategoryBundle &&
          props.dataArticleCategoryBundle.data && (
            <section>
              <div className="container">
                <div className="row">
                  <div className="col-12">
                    <PeopleLifestyleArticle
                      title={'People'}
                      is_mobile={isMobile}
                      dataArticle={
                        props.dataArticleCategoryBundle.data.beautiful_people
                      }
                      link_cta={process.env.NEXT_PUBLIC_ROOT_DOMAIN}
                      slug_url={'/blog/category/beautiful-people'}
                      section_name={'people'}
                    />
                  </div>
                </div>
              </div>
            </section>
          )}
        {!!props.dataArticleCategoryBundle &&
          props.dataArticleCategoryBundle.data && (
            <section>
              <div className="container">
                <div className="row">
                  <div className="col-12">
                    <PeopleLifestyleArticle
                      title={'Lifestyle'}
                      is_mobile={isMobile}
                      dataArticle={
                        props.dataArticleCategoryBundle.data.lifestyle
                      }
                      link_cta={process.env.NEXT_PUBLIC_ROOT_DOMAIN}
                      slug_url={'/blog/category/lifestyle'}
                      section_name={'lifestyle'}
                    />
                  </div>
                </div>
              </div>
            </section>
          )}

        <section>
          <div className="container fluid">
            <div className="row">
              <div className="col-12">
                <Video
                  is_mobile={isMobile}
                  dataVideo={props.dataVideo && props.dataVideo.data}
                />
              </div>
            </div>
          </div>
        </section>

        <section>
          <div className="container">
            <div className="row">
              <div className="col-12">
                <p className="main-text">
                  Female Daily, kumpulan informasi kecantikan terkini untuk
                  beauty enthusiast Indonesia.
                </p>
                <p className="main-subtext">
                  Temukan informasi terkini seputar trend kecantikan, makeup,
                  skincare, tutorial, produk dan perawatan tubuh untuk para
                  beauty enthusiast.
                </p>
              </div>
            </div>
          </div>
        </section>

        <style>
          {`
            .banner_container_billboard {
              padding: 0 !important;
            }
            .main-text {
              font-family: Josefin Sans, sans-serif;
              font-style: normal;
              font-weight: 600;
              font-size: 20px;
              line-height: 24px;
              letter-spacing: -0.05em;
              text-transform: capitalize;
              color: #000000;
              margin: 0 0 8px 0;
            }

            .main-subtext {
              font-family: Roboto;
              font-style: normal;
              font-weight: normal;
              font-size: 16px;
              line-height: 26px;
              color: #454F5B;
              margin: 0 0 24px 0;
            }

            section {
              margin-bottom: 60px;
            }

            @media only screen and (max-width: 600px) {

              .main-subtext {
                margin: 0 0 16px 0;
              }

              section {
                margin-bottom: 40px;
              }

            }
			`}
        </style>
      </main>
    </Layout>
  )
}

export const getServerSideProps = wrapper.getServerSideProps(
  async ({ store, req, res, query }) => {
    // if (!!query.p) {
    //   res.writeHead(302, {
    //     Location: `/preview/${query.p}`,
    //   })
    //   res.end()
    // }

    let userAgent
    if (req) {
      // if you are on the server and you get a 'req' property from your context
      userAgent = req.headers['user-agent'] // get the user-agent from the headers
    } else {
      userAgent = navigator.userAgent // if you are on the client you can access the navigator from the window object
    }

    let is_mobile =
      !!userAgent &&
      Boolean(
        userAgent.match(
          /Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i,
        ),
      )
    let cookies,
      authorization = null,
      usrname = null

    const isServer = !!req
    if (req.headers.cookie) {
      cookies = cookie.parse(req.headers.cookie)
      authorization = cookies.token
      usrname = cookies.usrname
    }

    if (authorization) {
      await store.dispatch(
        loadSelf({
          payload: {
            api_env: process.env.NEXT_PUBLIC_NODE_ENV,
            env: Env.HEADERS,
            Authorization: authorization,
            is_server: isServer,
            is_allo: process.env.NEXT_PUBLIC_ALLO_STATUS === "ON",
          },
        }),
      )
    }

    store.dispatch(END)
    await store.sagaTask.toPromise()

    let site = is_mobile === true ? 'mobile' : 'desktop'

    const results = await Promise.allSettled([
    
      fetchWithCache(process.env.NEXT_PUBLIC_BEAUTY_FILES, 24),
      fetchWithCache(process.env.NEXT_PUBLIC_ARTICLE_BEAUTY, 24),
      fetchWithCache(`${process.env.NEXT_PUBLIC_CAMPAIGN}?limit=5`),
      fetchWithCache(`${process.env.NEXT_PUBLIC_DISCOVER_VIDEO}?limit=5`),
      fetchWithCache(`${process.env.NEXT_PUBLIC_POPULAR_ARTICLE}?limit=4`),

      fetch(`${process.env.NEXT_PUBLIC_ARTICLE}?limit=5`, {
        headers: { ...Env.HEADERS },
      }),
      fetch(
        `${process.env.NEXT_PUBLIC_ARTICLE_CATEGORIES}?slugs=lifestyle,beautiful_people&limit=5`,
        { headers: { ...Env.HEADERS } },
      ),
      fetch(`${process.env.NEXT_PUBLIC_TAG_BEAUTY}/featured?limit=5`, {
        headers: { ...Env.HEADERS },
      }),

      // ads_detik
      ads_detik(site, 'taghead'),
      ads_detik(site, 'tagfoot'),

      // fetchAds
      ...(is_mobile
        ? [
            fetchAds('staticbanner1', true),
            fetchAds('staticbanner2', true),
            fetchAds('staticbanner3', true),
          ]
        : [
            fetchAds('billboard', false),
            fetchAds('mediumrectangle1', false),
          ]),
    ])

    const [
      beautyFilesRes,
      tabArticleRes,
      articleCampaignRes,
      videoRes,
      popularArticlesRes,
      articleLatestRes,
      articleCategoryBundleRes,
      articleFeaturedRes,
      adsHeadRes,
      adsFootRes,
      ...adsRes
    ] = results

    const resPopularArticles =
      popularArticlesRes.status === 'fulfilled' ? popularArticlesRes.value ?? [] : []

    const resBeautyFiles =
      beautyFilesRes.status === 'fulfilled' ? beautyFilesRes.value ?? [] : []

    const resArticleFeatured =
      articleFeaturedRes.status === 'fulfilled'
        ? await articleFeaturedRes.value.json()
        : []

    const resArticleCategoryBundle =
      articleCategoryBundleRes.status === 'fulfilled'
        ? await articleCategoryBundleRes.value.json()
        : []

    const resVideo =
      videoRes.status === 'fulfilled' ? videoRes.value ?? [] : []

    const resArticleLatest =
      articleLatestRes.status === 'fulfilled'
        ? await articleLatestRes.value.json()
        : []

    const resArticleCampaign =
      articleCampaignRes.status === 'fulfilled' ? articleCampaignRes.value ?? [] : []

    const resTabArticle =
      tabArticleRes.status === 'fulfilled' ? tabArticleRes.value ?? [] : []

    const adsHead =
      adsHeadRes.status === 'fulfilled' ? adsHeadRes.value ?? null : null
    const adsFoot =
      adsFootRes.status === 'fulfilled' ? adsFootRes.value ?? null : null

    let ads = {
      billboard: null,
      mediumrectangle1: null,
      static1: null,
      static2: null,
      static3: null,
    }

    if (is_mobile) {
      ads = {
        billboard: null,
        mediumrectangle1: null,
        static1: adsRes[0]?.status === 'fulfilled' ? adsRes[0].value : null,
        static2: adsRes[1]?.status === 'fulfilled' ? adsRes[1].value : null,
        static3: adsRes[2]?.status === 'fulfilled' ? adsRes[2].value : null,
      }
    } else {
      ads = {
        billboard: adsRes[0]?.status === 'fulfilled' ? adsRes[0].value : null,
        mediumrectangle1:
          adsRes[1]?.status === 'fulfilled' ? adsRes[1].value : null,
        static1: null,
        static2: null,
        static3: null,
      }
    }

    return {
      props: {
        is_mobile,
        dataVideo: resVideo || null,
        dataBeautyFiles: resBeautyFiles || null,
        dataPopularArticles: resPopularArticles || null,
        dataArticleCategoryBundle: resArticleCategoryBundle || null,
        dataArticleLatest: resArticleLatest || null,
        dataArticleCampaign: resArticleCampaign || null,
        dataTabArticle: resTabArticle || null,
        dataArticleFeatured: resArticleFeatured || null,
        ads,
        adsHead,
        adsFoot,
      },
      // Next.js will attempt to re-generate the page:
      // - When a request comes in
      // - At most once every 10 seconds
      // revalidate: 30, // In seconds
    }
  },
)

export default Home
